import { put, select, takeLatest } from 'redux-saga/effects'
import { getInsuranceInformationStateSelector } from '../selectors'
import { IInsuranceInformationState } from '../store/insuranceInformation.types'
import { setInsured } from '../store/insuranceInformation.actions'
import { OptionsConstants } from '../../options/store/options.constants'
import { getInsuranceInformationOptionsSelector } from '../../options/selectors/getInsuranceInformationOptions.selector'
import { IInsuranceInformationOptionsState } from '../../options/store/options.types'

export function* clearInsuredValue() {
  const insuranceInformation: IInsuranceInformationState = yield select(getInsuranceInformationStateSelector)
  const insuranceInformationOptions: IInsuranceInformationOptionsState = yield select(
    getInsuranceInformationOptionsSelector
  )
  const { insuranceInformationData } = insuranceInformation
  const { insured } = insuranceInformationData
  const { insuredOptions } = insuranceInformationOptions
  if (insured && insuredOptions.findIndex((option) => option.id === insured.id) === -1) {
    yield put(setInsured(null))
  }
}

export function* clearInsuredValueSaga() {
  yield takeLatest([OptionsConstants.SET_INSURED_OPTIONS], clearInsuredValue)
}
